var identity = function identity(x) {
  return x;
};

export default identity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/identity.js
// module id = ./node_modules/bootstrap-vue/esm/utils/identity.js
// module chunks = 0 1 2 4 5